<template lang="pug">
  v-dialog(v-model='dialog' persistent='' max-width='90%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense class='d-flex justify-center' v-if="read === false")
                  //v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined @keyup.enter='enterClickedOrden' type="Number" min="0" hint="Presione Enter" v-model='codigoOrden' label='Código de Orden' append-icon='mdi-clipboard-text-search')
                  v-btn.ma-1(color='success' dark @click='cargarOrdenes()')
                    | Cargar
                v-row(v-if="read === false")
                  v-col(cols='12' sm='12' md='12')
                    v-data-table.elevation-6(:headers="headersOrdenes" :items='ordenes' :search='search' locale='ES' :footer-props="{itemsPerPageText: 'Ordenes por página'}")
                      template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                      template(v-slot:top)
                        v-toolbar(flat color='primary' dark)
                          v-toolbar-title.justify-center Ordenes de Compra
                          v-divider.mx-4(inset vertical)
                          v-spacer
                          v-text-field.text-xs-center.px-2(v-model='search' label='Búsqueda' single-line hide-details color='success')
                          v-spacer
                      template(v-slot:item.action='{ item }')
                        v-tooltip(bottom='')
                          template(v-slot:activator='{ on }')
                            v-icon.mr-2(color='indigo', @click='showItem(item)' v-on="on") mdi-eye
                          | Detalle
                        v-tooltip(bottom='')
                          template(v-slot:activator='{ on }')
                            v-icon(color='success', @click='assignItem(item)' v-on="on") mdi-clipboard-arrow-down-outline
                          | Asignar Documento
                      template(v-slot:no-data)
                        h2 Campo de Código vacío
                p(v-if="read === false")
                v-row(v-if="add")
                  v-col(cols='12' sm='12' md='12')
                    v-data-table.elevation-6(:headers="headersOrdenes2" :items='ordenes2' locale='ES' :search2='search2' :footer-props="{itemsPerPageText: 'Ordenes por página'}")
                      template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                      template(v-slot:top='')
                        v-toolbar(flat color='primary' dark)
                          v-toolbar-title Ordenes Asignadas
                          v-divider.mx-4(inset='' vertical='')
                          v-spacer
                          v-text-field.text-xs-center(v-model='search2' label='Búsqueda' single-line='' hide-details='' color='#e95d3d')
                          v-spacer
                      template(v-slot:item.action='{ item }')
                        v-tooltip(bottom='')
                          template(v-slot:activator='{ on }')
                            v-icon.mr-2(color='indigo', @click='editItem(item, true)' v-on="on") mdi-eye
                          | Detalle
                        v-tooltip(bottom='' v-if="read === false")
                          template(v-slot:activator='{ on }')
                            v-icon.mr-2(v-if='validarModificar()', color='warning', @click='editItem(item, false)' v-on="on") mdi-pencil
                          | Editar
                        v-tooltip(bottom='' v-if="read === false")
                          template(v-slot:activator='{ on }')
                            v-icon.mr-2(v-if='validarEliminar()' color='error' @click='eliminar(item)' v-on="on") mdi-delete
                          | Eliminar Documento Asignado
                p
                v-row(dense)
                  v-col(cols='12' sm='12' md='3')
                    v-text-field(dense outlined readonly v-model='form.piezasGeneralOrd' label='Total de piezas' suffix="Und")
                  v-col(cols='12' sm='12' md='3')
                    v-text-field(dense outlined readonly v-model='form.kilogramosGeneralOrd' label='Total de kilogramos' suffix="Kg")
                  v-col(cols='12' sm='12' md='3')
                    v-text-field(dense outlined readonly v-model='form.piesCubicosGeneralOrd' label='Total de Pies Cúbicos' suffix="ft³")
                  v-col(cols='12' sm='12' md='3')
                    v-text-field(dense outlined readonly v-model='form.metroCubicoGeneralOrd' label='Total de Metros Cúbicos' suffix="m³")
                v-row(dense class='d-flex justify-end')
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined readonly v-model='form.totalGeneralOrd' label='TOTAL' prefix="$")
                v-row(dense class='d-flex justify-start')
                  v-icon.mr-2(color='black') mdi-information-outline
                  h3(style="color: black") Un estimado de {{estimado}} contenedor(es) para la reserva
            p
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Itinerario Estimado
              v-card-text
                v-row(dense class='d-flex justify-center')
                  v-col(cols='12' sm='12' md='4' v-if='editedIndex > -1' )
                    v-text-field(dense outlined readonly v-model='form.nroExpediente' label='Nro de Documento')
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined :readonly='read' type="Number" min="0" v-model='form.nroContenedores' label='Nro de Contendores')
                v-row(dense)
                  table.tabla(border='0' width='80%' align='center')
                    tr(style="border: 1px solid grey;")
                      td(align="center")
                        div
                          span.bold(style='color: black') ETD 1
                      td(align="center")
                        div
                          span.bold(style='color: black') ETA 1
                      td(align="center")
                        div
                          span.bold(style='color: black') ETD 2
                      td(align="center")
                        div
                          span.bold(style='color: black') ETA 2
                      td(align="center")
                        div
                          span.bold(style='color: black') ETA 3
                    tr(align='center')
                      td.inputt
                        div(v-if="!read")
                          v-dialog(ref='dialogETD1' v-model='modalETD1' :return-value.sync='date' persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined style='margin-bottom: -13px;' v-model='form.fechaETD1' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='form.fechaETD1' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalETD1 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogETD1.save(date)') Ok
                        div(v-else)
                          v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETD1' prepend-inner-icon='event')
                      td.inputt
                        div(v-if="!read")
                          v-dialog(ref='dialogETA1' v-model='modalETA1' :return-value.sync='date' persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined style='margin-bottom: -13px;' v-model='form.fechaETA1' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='form.fechaETA1' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalETA1 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogETA1.save(date)') Ok
                        div(v-else)
                          v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETA1' prepend-inner-icon='event')
                      td.inputt
                        div(v-if="!read")
                          v-dialog(ref='dialogETD2' v-model='modalETD2' :return-value.sync='date' persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined style='margin-bottom: -13px;' v-model='form.fechaETD2' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='form.fechaETD2' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalETD2 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogETD2.save(date)') Ok
                        div(v-else)
                          v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETD2' prepend-inner-icon='event')
                      td.inputt
                        div(v-if="!read")
                          v-dialog(ref='dialogETA2' v-model='modalETA2' :return-value.sync='date' persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined style='margin-bottom: -13px;' v-model='form.fechaETA2' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='form.fechaETA2' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalETA2 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogETA2.save(date)') Ok
                        div(v-else)
                          v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETA2' prepend-inner-icon='event')
                      td.inputt
                        div(v-if="!read")
                          v-dialog(ref='dialogETA3' v-model='modalETA3' :return-value.sync='date' persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined style='margin-bottom: -13px;' v-model='form.fechaETA3' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='form.fechaETA3' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalETA3 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogETA3.save(date)') Ok
                        div(v-else)
                          v-text-field(dense outlined readonly style='margin-bottom: -13px;' v-model='form.fechaETA3' prepend-inner-icon='event')
                    tr(align='center')
                      td.inputt
                        div(v-if="editedIndex === -1")
                          v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETD1' label='País' :items='paisETD1Array' @change="changePaisETD1")
                        div(v-else)
                          v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETD1._id' label='País' :items='paisETD1Array' @change="changePaisETD1")
                      td.inputt
                        div(v-if="editedIndex === -1")
                          v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETA1' label='País' :items='paisETA1Array' @change="changePaisETA1")
                        div(v-else)
                          v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETA1._id' label='País' :items='paisETA1Array' @change="changePaisETA1")
                      td.inputt
                        div(v-if="editedIndex === -1")
                          v-autocomplete(dense outlined readonly style='margin-bottom: -13px;' v-model='form.paisETA1' label='País' :items='paisETA1Array' @change="changePaisETA1")
                        div(v-else)
                          v-autocomplete(dense outlined readonly style='margin-bottom: -13px;' v-model='form.paisETA1._id' label='País' :items='paisETA1Array' @change="changePaisETA1")
                      td.inputt
                        div(v-if="editedIndex === -1")
                          v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETA2' label='País' :items='paisETA2Array' @change="changePaisETA2")
                        div(v-else)
                          v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.paisETA2._id' label='País' :items='paisETA2Array' @change="changePaisETA2")
                      td.inputt

                    tr(align='center')
                      td.inputt
                        v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.puertoETD1' label='Puerto' :items='puertoETD1Array')
                      td.inputt
                        v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.puertoETA1' label='Puerto' :items='puertoETA1Array')
                      td.inputt
                        v-autocomplete(dense outlined readonly style='margin-bottom: -13px;' v-model='form.puertoETA1' label='Puerto' :items='puertoETA1Array')
                      td.inputt
                        v-autocomplete(dense outlined :readonly='read' style='margin-bottom: -13px;' v-model='form.puertoETA2' label='Puerto' :items='puertoETA2Array')
                      td.inputt
      v-card-actions
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-spacer
        v-btn(v-if='!read' color='success' small dark @click='save')
          v-icon mdi-content-save
          | Guardar
    ImportacionDetalleProOrd(:dialogDetalleProOrd='dialogDetalleProOrd' @closeDetalleProOrd='closeDetalleProOrd' :FormDetalleProOrd='formOrden')
    ImportacionDetalleOrd(:dialogDetalleOrd='dialogDetalleOrd' @closeDetalleOrd='closeDetalleOrd' @asignar='asignar')
    Loading(:dialogLoading='dialogLoading')
</template>

<script>
import Api from '@/services/methods'
import Loading from '../Loading'
import ImportacionDetalleProOrd from './ImportacionDetalleProOrd'
import ImportacionDetalleOrd from './ImportacionDetalleOrd'
import { EventBus } from '../../Events'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    search: '',
    search2: '',
    dialogETD1: false, // fechas
    modalETD1: false,
    dialogETA1: false,
    modalETA1: false,
    dialogETD2: false,
    modalETD2: false,
    dialogETA2: false,
    modalETA2: false,
    dialogETA3: false,
    modalETA3: false,
    dialogLoading: false,
    dialogDetalleProOrd: false,
    dialogDetalleOrd: false,
    add: false,
    modificar: false,
    estimado: 0,
    permisosImportacion: {},
    pais: [],
    paisETD1Array: [],
    puertoETD1Array: [],
    paisETA1Array: [],
    puertoETA1Array: [],
    paisETA2Array: [],
    puertoETA2Array: [],
    headersOrdenes: [
      { text: 'Nro. Orden', value: 'codigoOrd', align: 'center' },
      { text: 'Proveedor', value: 'proveedorOrd.nombre', align: 'center' },
      { text: 'Fecha Emisión', value: 'fec_emis', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    headersOrdenes2: [
      { text: 'Nro. Orden', value: 'codigoOrd', align: 'center' },
      { text: 'Proveedor', value: 'proveedorOrd.nombre', align: 'center' },
      { text: 'Fecha cierre y envío', value: 'fechaCyEOrd', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    ordenes: [],
    ordenes2: [],
    ordenesAux: {},
    codigoOrden: '',
    form: {
      nroExpediente: 0,
      nroContenedores: 0,
      transito: 0,
      ordenes: {
        codigoOrd: '',
        fechaCyEOrd: '',
        proveedorOrd: {},
        facturaProvOrd: '',
        productosOrd: [],
        totalOrd: 0,
        kilogramosOrd: 0,
        piesCubicosOrd: 0,
        metroCubicoOrd: 0,
        descripcionProdOrd: '',
        piezasOrd: ''
      },
      fechaETD1: '',
      fechaETA1: '',
      fechaETD2: '',
      fechaETA2: '',
      fechaETA3: '',
      paisETD1: [],
      paisETA1: [],
      paisETD2: [],
      paisETA2: [],
      almacenLlegada: '',
      puertoETD1: null,
      puertoETA1: null,
      puertoETD2: null,
      puertoETA2: null,
      piezasGeneralOrd: 0,
      kilogramosGeneralOrd: 0,
      piesCubicosGeneralOrd: 0,
      metroCubicoGeneralOrd: 0,
      totalGeneralOrd: 0
    },
    defaultForm: {
      nroExpediente: 0,
      nroContenedores: 0,
      transito: 0,
      ordenes: {
        codigoOrd: '',
        fechaCyEOrd: '',
        proveedorOrd: {},
        facturaProvOrd: '',
        productosOrd: [],
        totalOrd: 0,
        kilogramosOrd: 0,
        piesCubicosOrd: 0,
        metroCubicoOrd: 0,
        descripcionProdOrd: '',
        piezasOrd: ''
      },
      fechaETD1: '',
      fechaETA1: '',
      fechaETD2: '',
      fechaETA2: '',
      fechaETA3: '',
      paisETD1: [],
      paisETA1: [],
      paisETD2: [],
      paisETA2: [],
      almacenLlegada: '',
      puertoETD1: null,
      puertoETA1: null,
      puertoETD2: null,
      puertoETA2: null,
      piezasGeneralOrd: 0,
      kilogramosGeneralOrd: 0,
      piesCubicosGeneralOrd: 0,
      metroCubicoGeneralOrd: 0,
      totalGeneralOrd: 0
    },
    formOrden: { // form Ordenes
      codigoOrd: '',
      fec_emis: '',
      proveedorOrd: '',
      articulos: [
        {
          co_art: '',
          art_des: '',
          total_art: 0
        }
      ]
    },
    defaultFormOrden: {
      codigoOrd: '',
      fec_emis: '',
      proveedorOrd: '',
      articulos: [
        {
          co_art: '',
          art_des: '',
          total_art: 0
        }
      ]
    },
    formOrden2: {
      codigoOrd: '',
      fechaCyEOrd: '',
      proveedorOrd: '',
      productosOrd: [],
      piezasOrd: 0,
      totalOrd: 0,
      kilogramosOrd: 0,
      piesCubicosOrd: 0,
      metroCubicoOrd: 0
    },
    defaultFormOrden2: {
      codigoOrd: '',
      fechaCyEOrd: '',
      proveedorOrd: '',
      productosOrd: [],
      piezasOrd: 0,
      totalOrd: 0,
      kilogramosOrd: 0,
      piesCubicosOrd: 0,
      metroCubicoOrd: 0
    }
  }),

  components: {
    Loading,
    ImportacionDetalleProOrd,
    ImportacionDetalleOrd
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Orden Pendiente'
        : this.read
          ? 'Información de la Orden'
          : 'Modificar Orden'
    }
  },

  watch: {
    FormPadre (val) {
      if (Object.keys(val).length !== 0) {
        this.form = val
        this.ordenes2 = val.ordenes
        this.add = true
        this.estimado = Math.ceil(val.piesCubicosGeneralOrd / 2400)
        if (this.form.paisETD) { this.changePaisETD(this.form.paisETD._id) }
        if (this.form.paisETA1) { this.changePaisETA1(this.form.paisETA1._id) }
        if (this.form.paisETA2) { this.changePaisETA2(this.form.paisETA2._id) }
      }
    },
    'form.fechaETD1': function (val) {
      if (val) {
        if (this.form.fechaETA1 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETD1ETA1()
        }
        if (this.form.fechaETA1 !== '' && this.form.fechaETD2 !== '' && this.form.fechaETA2 !== '' && this.fechaETA3 !== '') {
          this.calculoTransito()
        }
      }
    },
    'form.fechaETA1': function (val) {
      if (val) {
        if (this.form.fechaETD1 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETD1ETA1()
        }
        if (this.form.fechaETD2 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETA1ETD2()
        }
      }
    },
    'form.fechaETD2': function (val) {
      if (val) {
        if (this.form.fechaETA1 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETA1ETD2()
        }
        if (this.form.fechaETA2 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETD2ETA2()
        }
      }
    },
    'form.fechaETA2': function (val) {
      if (val) {
        if (this.form.fechaETD2 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETD2ETA2()
        }
        if (this.form.fechaETA3 !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.validarETA2ETA3()
        }
      }
    },
    'form.fechaETA3': function (val) {
      if (val) {
        if (this.form.fechaETD1 !== '' && this.form.fechaETA1 !== '' && this.form.fechaETD2 !== '' && this.form.fechaETA2 !== '') {
          if (!this.validarETA2ETA3()) {
            this.calculoTransito()
          }
        } else {
          this.$swal({
            icon: 'error',
            title: 'Error!',
            text: 'Recuerde introducir las fechas anteriores'
          })
          this.form.fechaETA3 = ''
        }
      }
    }
  },

  created () {
    this.permisosImportacion = this.$store.state.usuario.Empresa[0].permisos.find(permiso => permiso.ruta === 'Importacion')
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarPaises()
    },

    listarPaises () {
      Api.get('/paisesImportacion')
        .then(response => {
          this.pais = response.data
          this.pais.map(data => {
            this.paisETD1Array.push({
              text: data.pais,
              value: data._id
            })
            this.paisETA1Array.push({
              text: data.pais,
              value: data._id
            })
            this.paisETA2Array.push({
              text: data.pais,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor, verique su conexión de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    cargarOrdenes () {
      this.ordenes = []
      this.dialogLoading = true
      Api.post('ordPendiente/consultaOrden')
        .then((response) => {
          if (response.data.status === 'denied') {
            this.dialogLoading = false
            this.$swal({
              icon: 'info',
              title: 'Sin datos!',
              text: response.data.message
            })
          } else {
            console.log('ORDENES', response.data)
            response.data.map(data => {
              this.ordenes.push({
                codigoOrd: data.doc_num,
                fec_emis: this.formato(data.fec_emis),
                proveedorOrd: data.proveedor,
                articulos: data.articulos,
                total_neto: data.total_neto,
                total_volumen: data.totalVolumen,
                total_peso: data.totalPeso,
                total_articulos: data.totalArticulos
              })
            })
            this.dialogLoading = false
          }
        })
        .catch((error) => {
          if (error.response) {
            this.dialogLoading = false
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: 'Error encontrado, verifique los datos o llame al administrador.'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    assignItem (item) {
      this.codigoOrden = ''
      let bool = false
      let array = {}
      if (this.ordenes2.length > 0) {
        for (let i = 0; i < this.ordenes2.length; i++) {
          if (item.codigoOrd !== this.ordenes2[i].codigoOrd) {
            bool = true
          } else {
            bool = false
            this.$swal({
              icon: 'error',
              title: 'Error de asignación!',
              text: 'La Orden ya se encuentra asignada'
            })
            break
          }
        }
        if (bool) {
          this.ordenesAux.codigoOrd = item.codigoOrd
          this.ordenesAux.fechaCyEOrd = item.fec_emis
          this.ordenesAux.proveedorOrd = item.proveedorOrd
          this.ordenesAux.productosOrd = item.articulos
          this.ordenesAux.piezasOrd = item.total_articulos
          this.ordenesAux.totalOrd = (item.total_neto).toFixed(2)
          this.ordenesAux.kilogramosOrd = (item.total_peso).toFixed(2)
          this.ordenesAux.piesCubicosOrd = (item.total_volumen).toFixed(2)
          this.ordenesAux.metroCubicoOrd = (item.total_volumen / 35.315).toFixed(2)
          this.ordenesAux.facturaProvOrd = ''
          this.ordenesAux.descripcionProdOrd = ''
          array = {
            ordenesAux: this.ordenesAux,
            read: this.read
          }
          EventBus.$emit('dataDetalleOrd', array)
          this.dialogDetalleOrd = true
        }
      } else {
        this.ordenesAux.codigoOrd = item.codigoOrd
        this.ordenesAux.fechaCyEOrd = item.fec_emis
        this.ordenesAux.proveedorOrd = item.proveedorOrd
        this.ordenesAux.productosOrd = item.articulos
        this.ordenesAux.piezasOrd = item.total_articulos
        this.ordenesAux.totalOrd = (item.total_neto).toFixed(2)
        this.ordenesAux.kilogramosOrd = (item.total_peso).toFixed(2)
        this.ordenesAux.piesCubicosOrd = (item.total_volumen).toFixed(2)
        this.ordenesAux.metroCubicoOrd = (item.total_volumen / 35.315).toFixed(2)
        this.ordenesAux.facturaProvOrd = ''
        this.ordenesAux.descripcionProdOrd = ''
        array = {
          ordenesAux: this.ordenesAux,
          read: this.read
        }
        EventBus.$emit('dataDetalleOrd', array)
        this.dialogDetalleOrd = true
      }
    },

    showItem (item) {
      this.formOrden = Object.assign({}, item)
      this.dialogDetalleProOrd = true
    },

    validarETD1ETA1 () {
      if (this.$moment(this.form.fechaETA1) <= this.$moment(this.form.fechaETD1)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 1 no puede ser menor o igual a ETD 1'
        })
        this.form.fechaETD1 = ''
        this.form.fechaETA1 = ''
        return true
      }
      return false
    },
    validarETA1ETD2 () {
      if (this.$moment(this.form.fechaETD2) <= this.$moment(this.form.fechaETA1)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETD 2 no puede ser menor o igual a ETA 1'
        })
        this.form.fechaETA1 = ''
        this.form.fechaETD2 = ''
        return true
      }
      return false
    },
    validarETD2ETA2 () {
      if (this.$moment(this.form.fechaETA2) <= this.$moment(this.form.fechaETD2)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 2 no puede ser menor o igual a ETD 2'
        })
        this.form.fechaETD2 = ''
        this.form.fechaETA2 = ''
        return true
      }
      return false
    },
    validarETA2ETA3 () {
      if (this.$moment(this.form.fechaETA3) <= this.$moment(this.form.fechaETA2)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 3 no puede ser menor o igual a ETA 2'
        })
        this.form.fechaETA2 = ''
        this.form.fechaETA3 = ''
        this.dialog4 = false
        return true
      }
      return false
    },

    validarModificar () {
      return this.permisosImportacion?.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosImportacion?.accion.includes('Eliminar')
    },

    changePaisETD1 (data) {
      const pt = this.pais.find(pt => pt._id === data)
      this.puertoETD1Array = []
      for (let i = 0; i < pt.puertos.length; i++) {
        this.puertoETD1Array.push(pt.puertos[i].nombrePuerto)
      }
    },
    changePaisETA1 (data) {
      const pt = this.pais.find(pt => pt._id === data)
      this.puertoETA1Array = []
      for (let i = 0; i < pt.puertos.length; i++) {
        this.puertoETA1Array.push(pt.puertos[i].nombrePuerto)
      }
    },
    changePaisETA2 (data) {
      const pt = this.pais.find(pt => pt._id === data)
      this.puertoETA2Array = []
      for (let i = 0; i < pt.puertos.length; i++) {
        this.puertoETA2Array.push(pt.puertos[i].nombrePuerto)
      }
    },

    calculoTransito () {
      this.form.transito = this.$moment(this.form.fechaETA3).diff(this.$moment(this.form.fechaETD1), 'days')
    },

    formato (fecha) {
      return fecha.slice(0, 10)
    },

    editItem (item, bool) {
      if (bool === false) { this.modificar = true }
      this.ordenesAux = Object.assign({}, item)
      let array = {
        ordenesAux: this.ordenesAux,
        read: bool
      }
      EventBus.$emit('dataDetalleOrd', array)
      this.dialogDetalleOrd = true
    },

    asignar (data) {
      if (this.modificar === false) {
        this.ordenes2.push(data)
        this.form.piezasGeneralOrd = 0
        this.form.totalGeneralOrd = 0
        this.form.kilogramosGeneralOrd = 0
        this.form.piesCubicosGeneralOrd = 0
        this.form.metroCubicoGeneralOrd = 0
        for (let k = 0; k < this.ordenes2.length; k++) {
          this.form.piezasGeneralOrd += parseFloat(this.ordenes2[k].piezasOrd)
          this.form.totalGeneralOrd += parseFloat(this.ordenes2[k].totalOrd)
          this.form.kilogramosGeneralOrd += parseFloat(this.ordenes2[k].kilogramosOrd)
          this.form.piesCubicosGeneralOrd += parseFloat(this.ordenes2[k].piesCubicosOrd)
          this.form.metroCubicoGeneralOrd += parseFloat(this.ordenes2[k].metroCubicoOrd)
        }
        this.estimado = Math.ceil(this.form.piesCubicosGeneralOrd / 2400)
        this.form.piezasGeneralOrd = parseFloat((this.form.piezasGeneralOrd).toFixed(2))
        this.form.totalGeneralOrd = parseFloat((this.form.totalGeneralOrd).toFixed(2))
        this.form.kilogramosGeneralOrd = parseFloat((this.form.kilogramosGeneralOrd).toFixed(2))
        this.form.piesCubicosGeneralOrd = parseFloat((this.form.piesCubicosGeneralOrd).toFixed(2))
        this.form.metroCubicoGeneralOrd = parseFloat((this.form.metroCubicoGeneralOrd).toFixed(2))
        this.add = true
        this.dialogDetalleOrd = false
        this.ordenesAux = {}
      } else {
        for (let i = 0; i < this.ordenes2.length; i++) {
          if (this.ordenes2[i].codigoOrd === data.codigoOrd) {
            this.$set(this.ordenes2, i, data)
          }
        }
        this.form.piezasGeneralOrd = 0
        this.form.totalGeneralOrd = 0
        this.form.kilogramosGeneralOrd = 0
        this.form.piesCubicosGeneralOrd = 0
        this.form.metroCubicoGeneralOrd = 0

        for (let k = 0; k < this.ordenes2.length; k++) {
          this.ordenes2[k].piezasOrd = parseFloat(this.ordenes2[k].piezasOrd)
          this.ordenes2[k].totalOrd = parseFloat(this.ordenes2[k].totalOrd)
          this.ordenes2[k].kilogramosOrd = parseFloat(this.ordenes2[k].kilogramosOrd)
          this.ordenes2[k].piesCubicosOrd = parseFloat(this.ordenes2[k].piesCubicosOrd)
          this.ordenes2[k].metroCubicoOrd = parseFloat(this.ordenes2[k].metroCubicoOrd)

          this.form.piezasGeneralOrd += this.ordenes2[k].piezasOrd
          this.form.totalGeneralOrd += this.ordenes2[k].totalOrd
          this.form.kilogramosGeneralOrd += this.ordenes2[k].kilogramosOrd
          this.form.piesCubicosGeneralOrd += this.ordenes2[k].piesCubicosOrd
          this.form.metroCubicoGeneralOrd += this.ordenes2[k].metroCubicoOrd
        }
        this.estimado = Math.ceil(this.form.piesCubicosGeneralOrd / 2400)

        this.form.piezasGeneralOrd = parseFloat((this.form.piezasGeneralOrd).toFixed(2))
        this.form.totalGeneralOrd = parseFloat((this.form.totalGeneralOrd).toFixed(2))
        this.form.kilogramosGeneralOrd = parseFloat((this.form.kilogramosGeneralOrd).toFixed(2))
        this.form.piesCubicosGeneralOrd = parseFloat((this.form.piesCubicosGeneralOrd).toFixed(2))
        this.form.metroCubicoGeneralOrd = parseFloat((this.form.metroCubicoGeneralOrd).toFixed(2))

        this.dialogDetalleOrd = false
        this.ordenesAux = {}
        this.modificar = false
      }
    },

    eliminar (item) {
      this.ordenes2.splice(this.ordenes2.indexOf(item), 1)
      this.form.piezasGeneralOrd = 0
      this.form.totalGeneralOrd = 0
      this.form.kilogramosGeneralOrd = 0
      this.form.piesCubicosGeneralOrd = 0
      this.form.metroCubicoGeneralOrd = 0

      if (this.ordenes2.length > 0) {
        for (let k = 0; k < this.ordenes2.length; k++) {
          this.ordenes2[k].piezasOrd = parseFloat(this.ordenes2[k].piezasOrd)
          this.ordenes2[k].totalOrd = parseFloat(this.ordenes2[k].totalOrd)
          this.ordenes2[k].kilogramosOrd = parseFloat(this.ordenes2[k].kilogramosOrd)
          this.ordenes2[k].piesCubicosOrd = parseFloat(this.ordenes2[k].piesCubicosOrd)
          this.ordenes2[k].metroCubicoOrd = parseFloat(this.ordenes2[k].metroCubicoOrd)

          this.form.piezasGeneralOrd += this.ordenes2[k].piezasOrd
          this.form.totalGeneralOrd += this.ordenes2[k].totalOrd
          this.form.kilogramosGeneralOrd += this.ordenes2[k].kilogramosOrd
          this.form.piesCubicosGeneralOrd += this.ordenes2[k].piesCubicosOrd
          this.form.metroCubicoGeneralOrd += this.ordenes2[k].metroCubicoOrd
        }
        this.estimado = Math.ceil(this.form.piesCubicosGeneralOrd / 2400)
        this.form.piezasGeneralOrd = parseFloat((this.form.piezasGeneralOrd).toFixed(2))
        this.form.totalGeneralOrd = parseFloat((this.form.totalGeneralOrd).toFixed(2))
        this.form.kilogramosGeneralOrd = parseFloat((this.form.kilogramosGeneralOrd).toFixed(2))
        this.form.piesCubicosGeneralOrd = parseFloat((this.form.piesCubicosGeneralOrd).toFixed(2))
        this.form.metroCubicoGeneralOrd = parseFloat((this.form.metroCubicoGeneralOrd).toFixed(2))
      } else {
        this.add = false
        this.form.piezasGeneralOrd = 0
        this.form.totalGeneralOrd = 0
        this.form.kilogramosGeneralOrd = 0
        this.form.piesCubicosGeneralOrd = 0
        this.form.metroCubicoGeneralOrd = 0
        this.estimado = 0
      }
    },

    close () {
      this.ordenes = []
      this.ordenes2 = []
      this.codigoOrden = ''
      this.add = false
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
      }, 300)
      this.$emit('close')
    },

    closeDetalleProOrd () {
      this.dialogDetalleProOrd = false
      setTimeout(() => {
        this.formOrden = Object.assign({}, this.defaultFormOrden)
      }, 300)
    },

    closeDetalleOrd () {
      this.dialogDetalleOrd = false
      setTimeout(() => {
        this.formOrden2 = Object.assign({}, this.defaultFormOrden2)
      }, 300)
    },

    validarOrdenes () {
      if (this.ordenes2.length < 1) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'No ha asignado ninguna orden'
        })
        return true
      }
      return false
    },

    validarFechaETA1 () {
      if (this.$moment(this.form.fechaETA1) <= this.$moment(this.form.fechaETD)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 1 no puede ser menor o igual a ETD'
        })
        this.form.fechaETD = ''
        this.form.fechaETA1 = ''
        return true
      }
      return false
    },
    validarFechaETA2 () {
      if (this.$moment(this.form.fechaETA2) <= this.$moment(this.form.fechaETA1)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 2 no puede ser menor o igual a ETA1'
        })
        this.form.fechaETA1 = ''
        this.form.fechaETA2 = ''
        return true
      }
      return false
    },
    validarFechaETA3 () {
      if (this.$moment(this.form.fechaETA3) <= this.$moment(this.form.fechaETA2)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'ETA 3 no puede ser menor o igual a ETA2'
        })
        this.form.fechaETA2 = ''
        this.form.fechaETA3 = ''
        return true
      }
      return false
    },
    validarFechas () {
      if (
        this.$moment(this.form.fechaETD1) < this.$moment(this.form.fechaETA1) && this.$moment(this.form.fechaETA1) < this.$moment(this.form.fechaETD2) &&
        this.$moment(this.form.fechaETD2) < this.$moment(this.form.fechaETA2) && this.$moment(this.form.fechaETA2) < this.$moment(this.form.fechaETA3)
      ) {
        return true
      }
      this.$swal({
        icon: 'error',
        title: 'Error!',
        text: 'Por favor, verifique las fechas para continuar'
      })
      return false
    },

    validarPaises () {
      if (this.form.paisETD1.length === 0 || this.form.paisETA1.length === 0 || this.form.paisETA2.length === 0) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Por favor, debe introducir los paises para continuar'
        })
        return true
      }
      return false
    },

    save () {
      if (!this.validarOrdenes() && this.validarFechas() && !this.validarPaises()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        this.form.ordenes = this.ordenes2
        console.log('FORM', this.form)
        if (this.editedIndex > -1) {
          console.log('FORM 1', this.form)
          Api.put('ordPendiente', this.form)
            .then(response => {
              this.$emit('edited')
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modiicar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          console.log('FORM 2', this.form)
          Api.post('ordPendiente', this.form)
            .then(response => {
              this.$emit('save')
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    }
  }
}
</script>
